var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClearFilter24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.854 4.354a.5.5 0 00-.708-.708l-14 14a.5.5 0 00.708.708L9 15.218V18.5c0 .306.108.6.303.836.47.567 1.315.654 1.895.206l2.286-1.788c.323-.25.516-.632.516-1.042v-2.287l3.596-3.398c.257-.248.404-.587.404-.945V6.207l1.854-1.853zM17 7.207l-7 7.02V18.5c0 .07.024.14.073.198a.378.378 0 00.514.052l2.286-1.788a.317.317 0 00.127-.25V14l.153-.147 3.749-3.546a.314.314 0 00.098-.225V7.207zM6 7.115c0-.621.526-1.154 1.213-1.155h.001l6.783.04a.5.5 0 10.006-1l-6.786-.04h-.003C6.008 4.96 5 5.908 5 7.115v2.967c0 .364.155.677.398.94.575.621 1.145 1.25 1.755 1.838a.5.5 0 00.694-.72 117.343 117.343 0 01-1.749-1.833.313.313 0 01-.098-.225V7.115z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearFilter24);
export default __webpack_public_path__ + "static/media/icon-clear-filter-24.d3653c47.svg";
export { ForwardRef as ReactComponent };